Vue.directive('auto-scroll-here', {
    inserted(el) {
        setTimeout(() => window.utils.scrollIt(el, 'smooth'), 200);
    },
});